export enum SupplierInvoiceTypeButtonsId {
  Download = 'Download',
  DownloadCsv = 'DownloadCsv',
  DownloadXlsx = 'DownloadXlsx',
  DownloadPdf = 'DownloadPdf',
}

export enum SupplierInvoiceFileType {
  csv = 1,
  xlsx,
  pdf,
}

export type InvoiceFileType = {
  id?: SupplierInvoiceFileType
  format?: string
  description?: string
}

export type InvoiceFileTypeValues = {
  [key in SupplierInvoiceTypeButtonsId]: InvoiceFileType
}

export const SupplierInvoiceFileTypeValues: InvoiceFileTypeValues = {
  Download: {},
  DownloadCsv: { id: SupplierInvoiceFileType.csv, format: 'csv', description: 'text/csv' },
  DownloadXlsx: {
    id: SupplierInvoiceFileType.xlsx,
    format: 'xlsx',
    description: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  },
  DownloadPdf: { id: SupplierInvoiceFileType.pdf, format: 'pdf', description: 'application/pdf' },
}

export const SupplierInvoiceTypeButtonOptions = [
  { id: SupplierInvoiceTypeButtonsId.DownloadCsv, label: 'Download as CSV' },
  { id: SupplierInvoiceTypeButtonsId.DownloadXlsx, label: 'Download as XLSX' },
  { id: SupplierInvoiceTypeButtonsId.DownloadPdf, label: 'Download as PDF' },
]

export const SupplierAllInvoicesButtonOptions = [
  { id: SupplierInvoiceTypeButtonsId.Download, label: 'Download all' },
  ...SupplierInvoiceTypeButtonOptions,
]

export const SupplierSelectedInvoicesButtonOptions = [
  { id: SupplierInvoiceTypeButtonsId.Download, label: 'Download selected' },
  ...SupplierInvoiceTypeButtonOptions,
]
